module.exports = __webpack_public_path__ + "static/img/ndvi.56cc9714.png";